import styled from "styled-components";

export const FooterButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	margin: 1rem 0;
	gap: 1rem;

	> button {
		max-width: 200px;
	}
`;
